import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TransferRequest, LocationInventorySummary } from '../../models';

@Component({
  selector: 'app-transfer-modal',
  templateUrl: './transfer-modal.component.html',
  styleUrls: ['./transfer-modal.component.scss']
})
export class TransferModalComponent implements OnInit {
  @Input() locations: LocationInventorySummary[] = [];
  @Output() onSubmit = new EventEmitter<TransferRequest>();
  @Output() onCancel = new EventEmitter<void>();

  transferForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.transferForm = this.fb.group({
      sourceLocationId: [null, Validators.required],
      targetLocationId: [null, Validators.required],
      matType: ['Wood', Validators.required],
      quantity: [null, [Validators.required, Validators.min(1)]]
    }, {
      validators: this.differentLocationsValidator
    });
  }

  get sourceLocationId() { return this.transferForm.get('sourceLocationId'); }
  get targetLocationId() { return this.transferForm.get('targetLocationId'); }
  get matType() { return this.transferForm.get('matType'); }
  get quantity() { return this.transferForm.get('quantity'); }

  /**
   * Custom validator to ensure source and target are different
   */
  differentLocationsValidator(group: FormGroup): {[key: string]: boolean} | null {
    const source = group.get('sourceLocationId')?.value;
    const target = group.get('targetLocationId')?.value;
    
    if (source && target && source === target) {
      return { sameLocation: true };
    }
    return null;
  }

  /**
   * Get available quantity for selected source location and mat type
   */
  getAvailableQuantity(): number {
    const sourceId = this.sourceLocationId?.value;
    const matType = this.matType?.value;
    
    if (!sourceId || !matType) return 0;
    
    const location = this.locations.find(loc => loc.locationId === sourceId);
    if (!location) return 0;
    
    return matType === 'Wood' ? location.woodAvailable : location.polyAvailable;
  }

  submit(): void {
    if (this.transferForm.valid) {
      const request: TransferRequest = {
        sourceLocationId: this.transferForm.value.sourceLocationId,
        targetLocationId: this.transferForm.value.targetLocationId,
        matType: this.transferForm.value.matType,
        quantity: this.transferForm.value.quantity,
        createdBy: null // Set by parent component via onTransferRequest handler
      };
      this.onSubmit.emit(request);
    }
  }

  cancel(): void {
    this.onCancel.emit();
  }
}
